<template lang="pug">
  #app
    dw-header
    router-view
    dw-footer
</template>

<script>
import DwHeader from "./components/header.vue";
import DwFooter from "./components/footer.vue";

export default {
  name: 'app',
  components: {
    DwHeader,
    DwFooter
  },
}
</script>

<style lang="sass">
@import 'base/base'
@import 'config'
#app
  width: 100%
  height: 100%
  padding-top: r(66)
</style>



// WEBPACK FOOTER //
// App.vue?2e1c1234